import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of, throwError } from 'rxjs';
import { AlertService } from '../utility-services/alert.service';
import { AuthService } from '../utility-services/auth.service';
import { CookieService } from "ngx-cookie-service";
import { Router } from '@angular/router';
import { ValidationErrorModel } from '@itb-monorepo/models';
import { TranslateService } from '@ngx-translate/core';
import { AUTH_SCOPE_TOKEN } from '@itb-monorepo/enums';
import { HTTP_ERROR_MESSAGE } from '../http-error-message.token';
import { HTTP_ERROR_RESPONSE } from '../http-error-response.token';
@Injectable({
  providedIn: 'root',
})
export class ErrorInterceptor implements HttpInterceptor {
  private cookieService = inject(CookieService);
  private authService = inject(AuthService);
  private alertService = inject(AlertService);
  private router = inject(Router);
  private translateService = inject(TranslateService);
  private scope = inject(AUTH_SCOPE_TOKEN);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const modifiedUrl = `${request.url}?v=1.94`;
    if (request.url.includes('.json')) {
      request = request.clone({ url: modifiedUrl });
    }
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const responseError = request.context.get(HTTP_ERROR_RESPONSE)
          ? error
          : error.error;
        const errorMessageKey = request.context.get(HTTP_ERROR_MESSAGE);
        if (errorMessageKey && error.status !== 401) {
          this.alertService.showToast({
            body: this.translateService.instant(errorMessageKey),
            type: 'danger',
          });
          return throwError(() => responseError);
        }
        if (error.status === 400) {
          const validationErrors =
            (error.error.validations as ValidationErrorModel[]) || [];
          if (validationErrors.length < 1) {
            this.alertService.showToast({
              body: error.error.message,
              type: 'danger',
            });
            return throwError(() => responseError);
          }
          const errorUl = document.createElement('ul');
          errorUl.classList.add('px-4');
          for (let index = 0; index < validationErrors.length; index++) {
            const err = validationErrors[index];
            const errorLi = document.createElement('li');
            errorLi.style.lineHeight = '2';
            let errorMessage = this.translateService.instant(err.tag, {
              field: this.translateService.instant(toPascalCase(err.field)),
            });
            if (errorMessage == '') {
              errorMessage = err.tag + ' ' + err.field;
            }
            errorLi.innerHTML = errorMessage + '.';
            errorUl.append(errorLi);
          }
          this.alertService.showToast({
            body: errorUl.outerHTML,
            type: 'danger',
          });
        } else {
          if (error.status > 0) {
            if (request.url.includes('announcement') && error.status == 501) {
              return of(new HttpResponse({ status: 201, body: error.error }));
            }
            const excluded = excludedEndpoints.filter((x) =>
              request.url.includes(x)
            );
            if (excluded?.length > 0 && error.status == 404) {
              return throwError(() => responseError);
            }
            this.alertService.showToast(
              {
                body: errorMessageKey
                  ? this.translateService.instant(errorMessageKey)
                  : error.error.message,
                type: 'danger',
              },
              'error',
              true
            );
            if (error.status === 401) {
              if (
                this.authService.isTokenExpired &&
                this.authService.hasRefreshToken &&
                this.scope != 'admins'
              )
                this.authService.refreshToken();
              else {
                if (
                  typeof sessionStorage !== 'undefined' &&
                  sessionStorage.clear instanceof Function
                ) {
                  sessionStorage.clear();
                  this.cookieService.deleteAll();
                  void this.router.navigate(['/auth', 'sign-in']);
                }
              }
            }
          }
        }
        return throwError(() => responseError);
      })
    );
  }
}

export function toPascalCase(str: string): string {
  return str.split('_').map(word => word.charAt(0).toUpperCase() + word.substring(1).toLowerCase()).join('');
}

const excludedEndpoints = [
  'member/v1/introducers/-/clients/',
  '/member/v1/introducers/current',
  '/member/v1/users/current/utm'
]
